<template>
  <div class="mt-4" v-if="c_user.edit || !field.edit_only">
    <!-- transition="dialog-bottom-transition" -->
    <v-dialog v-model="previewDialog" v-if="artwork">
      <!-- :lazy-src="`http://www.tb-cms.org/artworks/send_file_auth?path=/data/${prieviewFile.category}/${prieviewFile.artwork_id}/${prieviewFile.fname}&dtoken=IZcomzYtIPKvPPQWuyENLKmVkeNclv1e5`" -->
      <v-card>
        <v-img
          v-if="previewDialog && isImage(prieviewFile.fname)"
          :src="`${$globals.fileserver}/send_file_auth?path=/data/${prieviewFile.category}/${prieviewFile.artwork_id}/${prieviewFile.fname}&dtoken=IZcomzYtIPKvPPQWuyENLKmVkeNclv1e5`"
          class="grey lighten-2"
          contain
          @click="closePreviewDialog"
        >
          <!-- aspect-ratio="1" -->
          <template v-slot:placeholder>
            <v-layout fill-height align-center justify-center ma-0>
              <v-progress-circular
                indeterminate
                color="grey lighten-5"
              ></v-progress-circular>
            </v-layout>
          </template>
        </v-img>
      </v-card>
    </v-dialog>

    <!-- style="background-color:#fff; color: #fff;" -->
    <v-flex
      class="mt-2 mx-0 px-0 mb-4 py-0 elevation-0 xs12"
      v-if="download_rights"
    >
      <!-- <h3 class="subheading xs12 flex ml-0 text-uppercase"
        style="background-color:#f6f6f6; color: #fff; border-radius:2px;"
      >
        <v-icon class="mr-3 ml-3 mb-0 mt-2" color="black">cloud</v-icon>
        <span
          class="mb-0 pt-0 pb-0 mt-0" style="color: black; line-height: 2;"
        >{{field.title}} ({{files ? files.length : 0}} uploaded) </span>
                  <v-btn
            v-if="files && files.length > 0 || upload_rights"
            @click="showUpload=!showUpload"
            color
            icon
            small
            class="right mt-1 pt-0 mb-0"
          >
            <v-icon v-if="!showUpload">expand_more</v-icon>
            <v-icon v-if="showUpload">expand_less</v-icon>
          </v-btn>
      </h3> -->
      <v-flex
        style="background-color: #392939; border-radius: 25px; height: 30px"
        class="white--text text-uppercase body-2 elevation-0 mx-1"
      >
        <!-- <v-toolbar-side-icon></v-toolbar-side-icon> -->
        <v-btn
          @click="showUpload = !showUpload"
          icon
          small
          class="hidden-xs-only mt-1"
        >
          <v-icon :color="!files || files.length == 0 ? 'red' : 'white'" small
            >cloud</v-icon
          >
        </v-btn>
        <!-- <v-icon class="mr-3 ml-3 mb-0 mt-2" color="black">cloud</v-icon> -->
        <span class="ml-0 pl-0">{{ field.title }} </span>
        <span v-if="files && files.length > 0"
          >({{ files ? files.length : 0 }} uploaded)</span
        >
        <!-- <v-spacer></v-spacer> -->
        <v-btn
          v-if="files && files.length > 0"
          @click="showUpload = !showUpload"
          icon
          small
          class="right mt-1 pt-0 mb-0 nounderline"
        >
          <v-icon v-if="!showUpload" color="white">expand_more</v-icon>
          <v-icon v-if="showUpload" color="white">expand_less</v-icon>
        </v-btn>

        <!-- upload4 -->
        <v-btn
          v-else-if="upload_rights"
          round
          target="_blank"
          small
          flat
          :href="`${$globals.fileserver}/upload_files.html?id=${upload_relation_id}&category=${categoryC}&u=${c_user.id}`"
          color="white"
          style="text-decoration: none !important; background-color: #392939"
          class="black--text right mt-1 mr-1 mb-0 nounderline px-3 xs12"
          rel="noopener noreferrer"
        >
          <v-icon small color="white" class="nounderline mr-2"
            >cloud_upload</v-icon
          >
          Upload New
        </v-btn>
      </v-flex>

      <v-layout
        column
        class="mt-0"
        v-if="showUpload"
        style="background-color: ; color: #fff"
      >
        <!-- <v-card color="grey lighten-5" class="mb-5 px-3 pb-3"> -->
        <v-flex xs12 sm12 md12>
          <!-- <h4 class="title mb-2">Upload {{uploadCategory}} – 4 files uploaded -->
          <!-- </h4> -->
          <v-list
            class="mt-0 pl-0 xs12 elevation-0"
            style="background-color: #efefef; color: #fff"
          >
            <v-list-tile
              v-for="f in files"
              :key="f.id"
              avatar
              class="py-0 my-0 mx-0 px-0"
              style="border-bottom: 1px solid #b9a9b9"
            >
              <v-list-tile-avatar class="pl-0 ml-0">
                <v-icon v-if="isImage(f.fname)" medium color="#392939"
                  >photo</v-icon
                >
                <v-icon
                  v-else-if="
                    ['PDF', 'pdf'].includes(f.fname.substr(f.fname.length - 3))
                  "
                  color="red"
                  medium
                  >mdi-file-pdf</v-icon
                >
                <v-icon
                  v-else-if="
                    [
                      'OCX',
                      'ocx',
                      'DOC',
                      'doc',
                      'rtf',
                      'RTF',
                      'txt',
                      'TXT',
                    ].includes(f.fname.substr(f.fname.length - 3))
                  "
                  color="#392939"
                  medium
                  >mdi-file-document</v-icon
                >
                <v-icon
                  v-else-if="
                    ['LSX', 'lsx', 'XLS', 'xls'].includes(
                      f.fname.substr(f.fname.length - 3)
                    )
                  "
                  color="black"
                  medium
                  >mdi-file-document</v-icon
                >
                <v-icon
                  v-else-if="
                    ['AVI', 'avi', 'MOV', 'mov'].includes(
                      f.fname.substr(f.fname.length - 3)
                    )
                  "
                  color="#392939"
                  medium
                  >theaters</v-icon
                >
                <v-icon
                  v-else-if="
                    ['WMA', 'wma'].includes(f.fname.substr(f.fname.length - 3))
                  "
                  color="#392939"
                  medium
                  >mdi-film</v-icon
                >
                <v-icon
                  v-else-if="
                    ['ZIP', 'zip'].includes(f.fname.substr(f.fname.length - 3))
                  "
                  color="#392939"
                  medium
                  >mdi-folder-zip</v-icon
                >
                <v-icon
                  v-else-if="
                    ['EML', 'eml'].includes(f.fname.substr(f.fname.length - 3))
                  "
                  color="#392939"
                  medium
                  >mdi-email</v-icon
                >
                <v-icon
                  v-else-if="
                    ['NDD', 'ndd'].includes(f.fname.substr(f.fname.length - 3))
                  "
                  color="#392939"
                  medium
                  >description</v-icon
                >
                <v-icon v-else color="red" medium>help-center</v-icon>
              </v-list-tile-avatar>
              <v-list-tile-content>
                <v-list-tile-title
                  v-if="c_user.roles.find((f) => f.shortcut == 'file_d')"
                >
                  <a
                    :href="`${$globals.fileserver}/send_file_auth?path=/data/${f.category}//${f.artwork_id}/${f.fname}&dtoken=IZcomzYtIPKvPPQWuyENLKmVkeNclv1e5`"
                    :download="f.fname"
                    target="_blank"
                    style="font-weight: 500; color: #392939"
                    >{{ f.name ? f.name : f.fname }}</a
                  >
                </v-list-tile-title>
                <v-list-tile-title v-else>{{ f.fname }}</v-list-tile-title>
                <v-list-tile-sub-title style="font-weight: 500; color: #392939">
                  Uploaded
                  {{ new Date(f.created_at).toLocaleDateString('en-US') }}
                  <span v-if="f.uploaded_by > 0"
                    >by {{ get_abb(f.uploaded_by) }}
                  </span>
                </v-list-tile-sub-title>
              </v-list-tile-content>
              <v-list-tile-action class="mr-0 pr-0 text-xs-right">
                <v-flex layout class="mr-0 pr-0">
                  <v-flex class="mr-3" v-if="isImage(f.fname)">
                    <v-btn @click="view(f)" icon
                      ><v-icon color="#392939">visibility</v-icon></v-btn
                    >
                  </v-flex>
                  <v-flex v-if="c_user.delete_rights" class="mr-0 pr-0">
                    <v-btn @click="delete_file(f.id)" icon class="mr-0 pr-0">
                      <v-icon color="#392939">delete</v-icon>
                    </v-btn>
                  </v-flex>
                </v-flex>
              </v-list-tile-action>
            </v-list-tile>
            <!-- <v-divider></v-divider> -->
          </v-list>

          <!-- upload4 -->
          <v-btn
            small
            round
            target="_blank"
            :href="`${$globals.fileserver}/upload_files.html?id=${upload_relation_id}&category=${categoryC}&u=${c_user.id}`"
            v-if="upload_rights"
            color="#392939"
            text--color
            class="white--text right mt-0 mr-4 mb-2 px-3 xs12 nounderline"
            rel="noopener noreferrer"
          >
            <v-icon small color="white" class="mr-2 nounderline"
              >cloud_upload</v-icon
            >
            Upload New
          </v-btn>
          <!-- UPLOAD NEW -->
          <!-- <v-flex>
            <v-text-field class="ml-2" name="description" label="Description"></v-text-field>
          </v-flex>
          <v-btn @click="showUploadForm=!showUploadForm">submit</v-btn>
          <v-btn @click="showUploadForm=!showUploadForm">clear</v-btn> -->
        </v-flex>
      </v-layout>
    </v-flex>

    <!-- delete dialog -->
    <v-dialog v-model="dialog" width="500" v-if="artwork">
      <!-- <v-btn slot="activator" color="red lighten-2" dark>Delete</v-btn> -->

      <v-card>
        <v-card-title class="headline grey lighten-2" primary-title
          >Do you really want to delete this file?</v-card-title
        >

        <v-card-text>
          <div class="headline pt-2">{{ file_to_delete.fname }}</div>
          <br />uploaded by
          <b v-if="file_to_delete.uploaded_by">{{
            get_abb(file_to_delete.uploaded_by)
          }}</b>
          <br />on
          <b>{{ file_to_delete.created_at }}</b>
          <br />for artwork
          <b>{{ artwork.title }}</b>
          <br />by artist
          <b>{{ artwork.artist ? artwork.artist.name : 'no artist' }}</b>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red" flat @click="deleteItem">Yes</v-btn>
          <v-btn color="green" flat @click="cancelDelete">No</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  props: ['artwork', 'uploadCategory', 'field', 'id'],
  data: () => ({
    previewDialog: false,
    prieviewFile: {},
    dialog: false,
    file_to_delete: '',
    showUpload: false,
    showUploadForm: false,
    show: false,
    count: 3,
    // thumbnailWidth: 120,
    // thumbnailHeight: 120,
    // headers: { "artwork": "artwork.id" },
    // previewTemplate: `
    //   <div class="dz-preview dz-file-preview">
    //     <div class="dz-details">
    //       <input type="text" />
    //       <div class="dz-filename"><span data-dz-name></span></div>
    //       <div class="dz-size" data-dz-size></div>
    //       <img data-dz-thumbnail />
    //     </div>
    //     <div class="dz-progress"><span class="dz-upload" data-dz-uploadprogress></span></div>
    //     <div class="dz-success-mark"><span>✔</span></div>
    //     <div class="dz-error-mark"><span>✘</span></div>
    //     <div class="dz-error-message"><span data-dz-errormessage></span></div>
    //   </div>`
    // }
  }),
  computed: {
    categoryC() {
      return this.uploadCategory ? this.uploadCategory : this.field.name
    },
    upload_relation_id() {
      return this.artwork ? this.artwork.id : this.id ? this.id : null
    },
    upload_rights() {
      if (this.c_user && this.c_user.roles) {
        var a = this.c_user.roles.find((ur) => ur.shortcut === 'file_u')
        return a
      } else {
        return false
      }
    },
    download_rights() {
      if (this.field.name == 'artwork_literature') {
        return true
      } else {
        if (this.c_user && this.c_user.roles) {
          var a = this.c_user.roles.find((ur) => ur.shortcut === 'file_d')
          return a
        } else {
          return false
        }
      }
    },
    files() {
      // console.log(this.$store.state.users.users[2])
      if (
        this.artwork &&
        this.artwork.file_uploads &&
        this.artwork.file_uploads.length > 0 &&
        this.field.category
      ) {
        return this.artwork.file_uploads.filter(
          (f) =>
            f.artwork_id === this.artwork.id &&
            f.category === this.field.category
        )
      } else if (
        this.artwork &&
        this.artwork.file_uploads &&
        this.artwork.file_uploads.length > 0 &&
        this.uploadCategory
      ) {
        return this.artwork.file_uploads.filter(
          (f) =>
            f.artwork_id === this.artwork.id &&
            f.category === this.uploadCategory
        )
      } else {
        return []
      }
    },
  },
  methods: {
    view(f) {
      this.prieviewFile = f
      this.previewDialog = true
    },
    closePreviewDialog() {
      this.previewDialog = false
      this.prieviewFile = {}
    },
    delete_file(id) {
      this.dialog = true
      this.file_to_delete = this.artwork.file_uploads.find((f) => f.id === id)
    },
    deleteItem() {
      // const index = this.artwork.file_uploads.indexOf(this.file_to_delete)
      var i = this.artwork.file_uploads.indexOf(this.file_to_delete)
      if (i !== -1) {
        this.artwork.file_uploads.splice(i, 1)
      }
      this.$store.dispatch('deleteFileUpload', this.file_to_delete)
      this.file_to_delete = {}
      this.dialog = false
    },
    cancelDelete() {
      this.dialog = false
      this.file_to_delete = {}
    },
  },
}
</script>

<style scoped>
.v-toolbar__content,
.v-toolbar__extension {
  padding: 0 28px;
}
.v-btn--small {
  height: 20px !important;
}
a {
  text-decoration: none;
  /* line-height: 1; */
}
a:hover {
  text-decoration: underline;
}
.nounderline {
  text-decoration: none !important;
}
/* .card { min-width:250px;} */
</style>



// WEBPACK FOOTER //
// src/components/artworks/Upload.vue